export default "__VITE_ASSET__CDAin7vs__"